module.exports = __webpack_public_path__ + "static/media/quindio-2.b0bf7a22.jpg";